module.exports = __webpack_public_path__ + "static/media/reference.f5b97640.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/reference.svg
// module id = 360
// module chunks = 0